module.exports = __webpack_public_path__ + "toGroom-we-p-w.bc1bdb43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-p-w.jpg
// module id = +tmC
// module chunks = 0